<template>
    <div>
        <div style="background: #ffffff;position:relative;">
            <div class="search-condition-con" :class="'show'">
                <div class="search-condition">
                    <span class="label">400号码</span>
                    <div class="input-condition">
                        <el-autocomplete v-model="condition.tellnumber" :fetch-suggestions="querySearchHotline" placeholder="请输入400号码"  valueKey="hotline_number"></el-autocomplete>
                    </div>
                </div>
                <div class="search-condition">
                    <span class="label">400号码状态</span>
                    <div class="input-condition">
                        <el-select v-model="condition.frozen_status" >
                            <el-option value="" label="不限"></el-option>
                            <el-option value="0" label="启用"></el-option>
                            <el-option value="1" label="冻结"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="btn-condition">
                <el-button @click="handleSearch" type="primary" >查 询</el-button>
                <el-button @click="resetSearch" >清空条件</el-button>
            </div>
        </div>

        <div>
            <div class="clearfix" style="margin-bottom:5px;display:none">
                <el-button-group class="floatR">
                    <el-tooltip class="item" effect="dark" content="新增400大号" placement="top">
                        <el-button icon="el-icon-plus" @click="handleAdd" v-permission="'business.hotline.create'"></el-button>
                    </el-tooltip>
                </el-button-group>
            </div>
            <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
            >
                <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->

                <el-table-column label="400号码" prop="hotline_number"></el-table-column>
                <el-table-column  label="号码状态" prop="tstatus">
                    <template    slot-scope="scope" >
                        {{scope.row.tstatus}}<br v-if="scope.row.frozen_status ==1"/>
                        <span  v-if="scope.row.frozen_status==1" style="color: red">剩余{{scope.row.days}}天解冻</span>
                    </template>
                </el-table-column>
                <el-table-column  label="号码类型" prop="ttype"></el-table-column>
                <el-table-column  label="分机位数" prop="telephone_length"></el-table-column>
                <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
                <el-table-column width="180" >
                    <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                    <template slot="header"   slot-scope="scope">
                        <span style="color: #409EFF">操作</span>
                    </template>
                    <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                    <template slot-scope="scope">
                        <el-button  v-if='scope.row.frozen_status ==0' size="mini" v-permission="'business.hotline.changestatus'" @click="handleStop(scope.$index, scope.row)">冻结</el-button>
                        <el-button  v-if='scope.row.frozen_status ==1' size="mini" v-permission="'business.hotline.changestatus'" @click="handleStart(scope.$index, scope.row)">解冻</el-button>
                        <el-button size="mini" v-permission="'business.hotline.edit'" @click="openEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
            <template v-if="list.length > 0">
                <!-- :total="list.length" -->
                <el-pagination background layout="total,prev, pager, next" :total="pages.total" :page-size="pages.size" @current-change="currentChange"></el-pagination>
            </template>
        </div>
        <Edit ref="edit" :callback="initData" />
        <Add ref="Add" :callback="initData" />
    </div>
</template>
<style>
    .search-condition-con .search-condition{
        width: 30%;
    }
</style>
<script>
    import Edit from './Edit'
    import Add from './Add'
    import {editCunstomerHotlinesStatus, editHotlinesStatus, getHotlines} from "@/service/hotline";
    import {getHotlinesall, getProviders} from "@/service/hotline";
    export default {
        name: 'normal',
        components: {
            Edit,
            Add
        },
        data () {
            return {
                page:1,
                typeMap:{
                    1:'独立大号',
                    2:'公共大号'
                },
                statusMap:{
                    0:'启用',
                    1:'冻结',
                },
                pages:{
                    total:'',
                    size:''
                },
                condition: {
                    factorID:'',
                    siteID:'',
                    factor: '',
                    frozen_status:'',
                    site: '',
                    type: '',
                    status:'',
                    tellnumber:'',
                    balanceStatus:''
                },
                isLoading:false,
                list: [],
                providers : [
                    { id: '', name: '全部' }
                ],
            }
        },
        mounted() {
            this.initData()
            this.getProviders()
        },
        methods: {
            Thistime(){//当前日期
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth()+1;
                var day = date.getDate();
                var time = year+"-"+month+"-"+day;
                return time;
            },
            DateDiff(starDay, endDay) {  //sDate1和sDate2是yyyy-MM-dd格式
                var arr = [];
                var dates = [];
                // 设置两个日期UTC时间
                var db = new Date(starDay);
                var de = new Date(endDay);
                // 获取两个日期GTM时间
                var s = db.getTime() - 24 * 60 * 60 * 1000;
                var d = de.getTime() - 24 * 60 * 60 * 1000;

                // 获取到两个日期之间的每一天的毫秒数
                for (var i = s; i <= d;) {
                    i = i + 24 * 60 * 60 * 1000;
                    arr.push(parseInt(i))
                }

                // 获取每一天的时间  YY-MM-DD
                for( var j in arr ){
                    var time = new Date(arr[j]);
                    var year = time.getFullYear(time);
                    var mouth = (time.getMonth() + 1)>=10?(time.getMonth() + 1):('0'+(time.getMonth() + 1));
                    var day = time.getDate()>=10?time.getDate():('0'+time.getDate());
                    var YYMMDD = year + '-' + mouth + '-' + day;
                    dates.push(YYMMDD)
                }

                return dates.length//返回相差天数
            },
            openEdit(i,row) {
                this.$refs.edit
                && ( Object.assign(this.$refs.edit.info, row))
                && this.$refs.edit.open()
            },
            // 添加400大号
            handleAdd(){
                const providerList = [...this.providers];
                providerList.splice(0, 1);
                this.$refs.Add
                && (this.$refs.Add.providers = providerList)
                && this.$refs.Add.open()
            },
            //用于站点自动补全的查询
            async querySearchHotline(queryString, callback) {
                let query = {};
                let result = [];
                query['hotline_number'] = queryString;
                await getHotlinesall(query).then((data) => {
                    result = data
                });
                callback(result)
            },
            //清空
            resetSearch() {
                this.condition = {
                    factorID:'',
                    siteID:'',
                    factor: '',
                    site: '',
                    type: '',
                    status:'',
                    tellnumber:'',
                    balanceStatus:''
                };
                this.refreshPage();
            },
            //分页设置回调
            currentChange(page) {
                this.page = page;
                this.refreshPage();
            },
            //搜索
            handleSearch() {
                this.refreshPage();
            },
            //解冻
            handleStart(i,row) {
                this.$confirm('解冻后,该400号码重新释放,允许被绑定,是否确认?', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let query = {};
                    query['status'] = 0;
                    this.isLoading = true;
                    editHotlinesStatus(row.id,query).then(data=>{
                        this.refreshPage()
                    });
                    this.isLoading = false
                }).catch((e) => {
                    this.message({
                        content:e.message,
                        type:'error'
                    })
                });
            },
            //冻结
            handleStop(i,row) {
                this.$confirm('冻结后,该400号码不允许被绑定,是否确认?', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    let query = {};
                    query['status'] = 1;
                    this.isLoading = true;
                    editHotlinesStatus(row.id,query).then(data=>{
                        this.refreshPage()
                    });
                    this.isLoading = false
                }).catch((e) => {
                    this.message({
                        content:e.message,
                        type:'error'
                    })
                });
            },
            //刷新列表
            refreshPage() {
                let query = {};
                let form =  this.condition;
                query['hotline_number'] = form.tellnumber;
                query['frozen_status'] = form.frozen_status;
                query['page'] = this.page;
                // this.$message({
                //     type: '',
                //     message: err.message || '删除失败'
                // })
                this.isLoading = true;
                //query['factor_id'] = user.factor_id
                getHotlines(query).then((data) => {
                    let listData = data;
                    listData.data.forEach((item,i,list)=>{
                        listData.data[i].tstatus = this.statusMap[item.frozen_status];
                        listData.data[i].days = this.DateDiff(this.Thistime(),item.unfreeze_time);
                        listData.data[i].ttype = this.typeMap[item.type]
                        if (item.only_user_400 == 1) {
                            listData.data[i].hotline_number += '（直拔号）';
                        }
                    });
                    this.list = listData.data;
                    this.pages.size = data.pre_page;
                    this.pages.total = data.total
                });
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            /** 初始化数据请求 */
            async initData () {
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true;
                // 模拟fetch请求数据....
                let query = {};
                this.refreshPage();
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            // 400服务提供商
            getProviders(){
                getProviders({}).then((data) => {
                    this.providers = this.providers.concat(data.data)
                })
            },
        }
    }
</script>
